import {Image} from '@blesk-frontend/ui';

export const EmptyImage = () => {
  return (
    <div className="flex size-full items-center justify-center rounded border bg-bg-muted">
      <Image className="size-[72px] text-text-contrast" />
    </div>
  );
};
